export default __webpack_public_path__ + "static/media/employee.5dea4d20.svg";